import _ from "lodash";

export const setWebsiteDidLoad = state => {
    const newState = _.cloneDeep(state) || {};
    const newLoading = newState.loading = {};
    newLoading.firstPageHasFinishedLoading = true;

    return newState || {};
}
